import RouteIndex from "Routes/Index";
import { SyncProvider } from "./context/SyncContext";
import "./assets/scss/themes.scss";

function App() {
  return (
    <SyncProvider>
      <RouteIndex />
    </SyncProvider>
  );
}

export default App;
